import { Component, Input } from '@angular/core';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'export-downloads-modal',
  templateUrl: 'export-downloads-modal.component.html',
  styleUrls: ['export-downloads-modal.component.scss'],
})
export class ExportDownloadsModalComponent extends BaseModalComponent {
  @Input() data: any[];

  public setData(data: any[]) {
    this.data = data;
  }
}
